import React, { useState, useEffect } from 'react';
import api from '../services/api';

export default function Database() {
  const [activeTab, setActiveTab] = useState('apar');
  const [garduList, setGarduList] = useState([]);
  const [selectedGI, setSelectedGI] = useState('');

  const [aparList, setAparList] = useState([]);
  const [editApar, setEditApar] = useState(null);
  const [showAddApar, setShowAddApar] = useState(false);
  const [newApar, setNewApar] = useState({ kode_apar: '', jenis_isi: 'CARBON DIOXIDE', berat: '7 KG', lokasi_penempatan: '', status: 'aktif', ada_pressure_indicator: false });

  const [apdList, setApdList] = useState([]);
  const [editApd, setEditApd] = useState(null);
  const [showAddApd, setShowAddApd] = useState(false);
  const [newApd, setNewApd] = useState({ nama_item: '', kategori: '', jumlah_standar: 0 });

  const [p3kList, setP3kList] = useState([]);
  const [editP3k, setEditP3k] = useState(null);
  const [showAddP3k, setShowAddP3k] = useState(false);
  const [newP3k, setNewP3k] = useState({ nama_item: '', jumlah_standar: 1 });

  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => { loadGarduList(); }, []);
  useEffect(() => { if (selectedGI) loadData(); }, [selectedGI, activeTab]);

  const loadGarduList = async () => {
    try {
      const res = await api.get('/gardu');
      setGarduList(res.data.data || []);
      if (res.data.data?.length > 0) setSelectedGI(res.data.data[0].id);
    } catch (err) { console.error(err); }
  };

  const loadData = async () => {
    setIsLoading(true);
    try {
      if (activeTab === 'apar') {
        const res = await api.get(`/apar/daftar/${selectedGI}`);
        setAparList(res.data.data || []);
      } else if (activeTab === 'apd') {
        const res = await api.get(`/apd/standar/${selectedGI}`);
        setApdList(res.data.data || []);
      } else if (activeTab === 'p3k') {
        const res = await api.get('/p3k/master');
        setP3kList(res.data.data || []);
      }
    } catch (err) { console.error(err); }
    setIsLoading(false);
  };

  const showMsg = (text, isError = false) => {
    setMessage({ text, isError });
    setTimeout(() => setMessage(''), 3000);
  };

  // === APAR ===
  const addApar = async () => {
    setIsSaving(true);
    try {
      await api.post(`/apar/tambah`, { ...newApar, gardu_induk_id: selectedGI });
      showMsg('Unit APAR berhasil ditambahkan!');
      setShowAddApar(false);
      setNewApar({ kode_apar: '', jenis_isi: 'CARBON DIOXIDE', berat: '7 KG', lokasi_penempatan: '', status: 'aktif', ada_pressure_indicator: false });
      loadData();
    } catch (err) {
      showMsg('Gagal menambah APAR: ' + (err.response?.data?.message || err.message), true);
    }
    setIsSaving(false);
  };

  const saveApar = async () => {
    if (!editApar) return;
    setIsSaving(true);
    try {
      await api.put(`/apar/${editApar.id}`, {
        status: editApar.status,
        lokasi_penempatan: editApar.lokasi_penempatan,
        berat: editApar.berat,
        jenis_isi: editApar.jenis_isi,
      });
      showMsg('Data APAR berhasil disimpan!');
      setEditApar(null);
      loadData();
    } catch (err) { showMsg('Gagal menyimpan', true); }
    setIsSaving(false);
  };

  // === APD ===
  const saveApd = async () => {
    if (!editApd) return;
    setIsSaving(true);
    try {
      await api.put(`/apd/standar/${editApd.id}`, { jumlah_standar: editApd.jumlah_standar });
      showMsg('Standar APD berhasil disimpan!');
      setEditApd(null);
      loadData();
    } catch (err) { showMsg('Gagal menyimpan', true); }
    setIsSaving(false);
  };

  const addApd = async () => {
    setIsSaving(true);
    try {
      await api.post('/apd/master', newApd);
      showMsg('Item APD berhasil ditambahkan ke semua GI!');
      setShowAddApd(false);
      setNewApd({ nama_item: '', kategori: '', jumlah_standar: 0 });
      loadData();
    } catch (err) {
      showMsg('Gagal menambah APD: ' + (err.response?.data?.message || err.message), true);
    }
    setIsSaving(false);
  };

  // === P3K ===
  const addP3k = async () => {
    setIsSaving(true);
    try {
      await api.post('/p3k/master', newP3k);
      showMsg('Item P3K berhasil ditambahkan!');
      setShowAddP3k(false);
      setNewP3k({ nama_item: '', jumlah_standar: 1 });
      loadData();
    } catch (err) { showMsg('Gagal menambah P3K', true); }
    setIsSaving(false);
  };

  const saveP3k = async () => {
    if (!editP3k) return;
    setIsSaving(true);
    try {
      await api.put(`/p3k/master/${editP3k.id}`, { jumlah_standar: editP3k.jumlah_standar, nama_item: editP3k.nama_item });
      showMsg('Data P3K berhasil disimpan!');
      setEditP3k(null);
      loadData();
    } catch (err) { showMsg('Gagal menyimpan', true); }
    setIsSaving(false);
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'aktif': return 'bg-green-100 text-green-700';
      case 'perlu_perhatian': return 'bg-yellow-100 text-yellow-700';
      case 'tidak_siap':
      case 'tidak_aktif':
        return 'bg-red-100 text-red-700';
      default: return 'bg-gray-100 text-gray-700';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'aktif': return 'Aman';
      case 'perlu_perhatian': return 'Waspada';
      case 'tidak_siap': return 'Kritis';
      case 'tidak_aktif': return 'Kritis (Nonaktif)';
      default: return status;
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Database Master</h1>

      {message && (
        <div className={`mb-4 px-4 py-3 rounded-lg ${message.isError ? 'bg-red-50 text-red-700 border border-red-200' : 'bg-green-50 text-green-700 border border-green-200'}`}>
          {message.text}
        </div>
      )}

      <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 mb-4">
        <div className="flex flex-wrap gap-4 items-end">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Gardu Induk</label>
            <select value={selectedGI} onChange={(e) => setSelectedGI(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
              {garduList.map(gi => <option key={gi.id} value={gi.id}>{gi.nama}</option>)}
            </select>
          </div>
          <div className="flex gap-2">
            {[{ key: 'apar', label: '🧯 APAR' }, { key: 'apd', label: '🛡️ APD' }, { key: 'p3k', label: '🏥 P3K' }].map(tab => (
              <button key={tab.key} onClick={() => { setActiveTab(tab.key); setEditApar(null); setEditApd(null); setEditP3k(null); setShowAddApar(false); setShowAddP3k(false); }}
                className={`px-5 py-2 rounded-lg font-medium transition-colors ${activeTab === tab.key ? 'bg-green-700 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* ===== APAR ===== */}
      {activeTab === 'apar' && (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100">
          <div className="p-4 border-b border-gray-100 flex justify-between items-center">
            <h2 className="font-bold text-gray-800">Unit APAR ({aparList.length} unit)</h2>
            <button onClick={() => setShowAddApar(!showAddApar)}
              className="bg-green-700 text-white px-3 py-1.5 rounded-lg text-sm hover:bg-green-600">
              {showAddApar ? '✕ Batal' : '+ Tambah APAR'}
            </button>
          </div>

          {showAddApar && (
            <div className="p-4 bg-green-50 border-b border-gray-100">
              <h3 className="font-bold text-green-800 mb-3">Tambah Unit APAR Baru</h3>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">Kode APAR</label>
                  <input value={newApar.kode_apar} onChange={(e) => setNewApar({...newApar, kode_apar: e.target.value})}
                    className="w-full px-3 py-2 border rounded-lg text-sm" placeholder="APAR-GRT-010" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">Jenis Isi</label>
                  <select value={newApar.jenis_isi} onChange={(e) => setNewApar({...newApar, jenis_isi: e.target.value})}
                    className="w-full px-3 py-2 border rounded-lg text-sm">
                    <option value="CARBON DIOXIDE">CO2</option>
                    <option value="POWDER">POWDER</option>
                    <option value="FOAM">FOAM</option>
                    <option value="CLEAN AGENT">CLEAN AGENT</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">Berat</label>
                  <input value={newApar.berat} onChange={(e) => setNewApar({...newApar, berat: e.target.value})}
                    className="w-full px-3 py-2 border rounded-lg text-sm" placeholder="7 KG" />
                </div>
                <div className="col-span-2">
                  <label className="block text-xs font-medium text-gray-700 mb-1">Lokasi Penempatan</label>
                  <input value={newApar.lokasi_penempatan} onChange={(e) => setNewApar({...newApar, lokasi_penempatan: e.target.value})}
                    className="w-full px-3 py-2 border rounded-lg text-sm" placeholder="R. OPERATOR & PROTEKSI" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">Status</label>
                  <select value={newApar.status} onChange={(e) => setNewApar({...newApar, status: e.target.value})}
                    className="w-full px-3 py-2 border rounded-lg text-sm">
                    <option value="aktif">Aman</option>
                    <option value="perlu_perhatian">Waspada</option>
                    <option value="tidak_siap">Kritis</option>
                    <option value="tidak_aktif">Kritis (Nonaktif)</option>
                  </select>
                </div>
              </div>
              <div className="flex items-center gap-2 mt-3">
                <input type="checkbox" id="pressure" checked={newApar.ada_pressure_indicator}
                  onChange={(e) => setNewApar({...newApar, ada_pressure_indicator: e.target.checked})} />
                <label htmlFor="pressure" className="text-sm text-gray-700">Ada Pressure Indicator</label>
              </div>
              <div className="flex gap-2 mt-3">
                <button onClick={addApar} disabled={isSaving}
                  className="bg-green-700 text-white px-4 py-2 rounded-lg text-sm hover:bg-green-600 disabled:opacity-50">
                  {isSaving ? 'Menyimpan...' : '💾 Simpan APAR Baru'}
                </button>
              </div>
            </div>
          )}

          {isLoading ? <div className="flex justify-center p-8"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600"></div></div> : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Kode APAR</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Jenis & Berat</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Lokasi</th>
                    <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Status</th>
                    <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Aksi</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {aparList.map((apar, i) => (
                    <tr key={i} className="hover:bg-gray-50">
                      {editApar?.id === apar.id ? (
                        <>
                          <td className="px-4 py-3 font-medium">{apar.kode_apar}</td>
                          <td className="px-4 py-3">
                            <input value={editApar.jenis_isi} onChange={(e) => setEditApar({...editApar, jenis_isi: e.target.value})}
                              className="w-32 px-2 py-1 border rounded text-xs mr-1" />
                            <input value={editApar.berat} onChange={(e) => setEditApar({...editApar, berat: e.target.value})}
                              className="w-16 px-2 py-1 border rounded text-xs" />
                          </td>
                          <td className="px-4 py-3">
                            <input value={editApar.lokasi_penempatan} onChange={(e) => setEditApar({...editApar, lokasi_penempatan: e.target.value})}
                              className="w-full px-2 py-1 border rounded text-xs" />
                          </td>
                          <td className="px-4 py-3 text-center">
                            <select value={editApar.status} onChange={(e) => setEditApar({...editApar, status: e.target.value})}
                              className="px-2 py-1 border rounded text-xs">
                              <option value="aktif">Aman</option>
                              <option value="perlu_perhatian">Waspada</option>
                              <option value="tidak_siap">Kritis</option>
                              <option value="tidak_aktif">Kritis (Nonaktif)</option>
                            </select>
                          </td>
                          <td className="px-4 py-3 text-center">
                            <button onClick={saveApar} disabled={isSaving}
                              className="text-xs bg-green-600 text-white px-2 py-1 rounded mr-1">💾</button>
                            <button onClick={() => setEditApar(null)}
                              className="text-xs bg-gray-200 text-gray-700 px-2 py-1 rounded">✕</button>
                          </td>
                        </>
                      ) : (
                        <>
                          <td className="px-4 py-3 font-medium text-gray-900">{apar.kode_apar}</td>
                          <td className="px-4 py-3 text-gray-600">{apar.jenis_isi} {apar.berat}</td>
                          <td className="px-4 py-3 text-gray-600">{apar.lokasi_penempatan}</td>
                          <td className="px-4 py-3 text-center">
                            <span className={`px-2 py-1 rounded-full text-xs font-bold ${getStatusBadge(apar.status)}`}>
                              {getStatusLabel(apar.status)}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-center">
                            <button onClick={() => setEditApar({...apar})}
                              className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded hover:bg-blue-200">✏️ Edit</button>
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ===== APD ===== */}
      {activeTab === 'apd' && (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100">
          <div className="p-4 border-b border-gray-100 flex justify-between items-center">
            <div>
              <h2 className="font-bold text-gray-800">Standar APD ({apdList.length} item)</h2>
              <p className="text-xs text-gray-500">* Edit standar per GI yang dipilih</p>
            </div>
            <button onClick={() => setShowAddApd(!showAddApd)}
              className="bg-green-700 text-white px-3 py-1.5 rounded-lg text-sm hover:bg-green-600">
              {showAddApd ? '\u2715 Batal' : '+ Tambah APD'}
            </button>
          </div>

          {showAddApd && (
            <div className="p-4 bg-green-50 border-b border-gray-100">
              <h3 className="font-bold text-green-800 mb-3">Tambah Item APD Baru</h3>
              <p className="text-xs text-gray-500 mb-3">* Standar akan diterapkan sama untuk semua GI sekaligus</p>
              <div className="grid grid-cols-3 gap-3">
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">Nama Item</label>
                  <input value={newApd.nama_item} onChange={(e) => setNewApd({...newApd, nama_item: e.target.value})}
                    className="w-full px-3 py-2 border rounded-lg text-sm" placeholder="Nama item APD" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">Kategori</label>
                  <input value={newApd.kategori} onChange={(e) => setNewApd({...newApd, kategori: e.target.value})}
                    className="w-full px-3 py-2 border rounded-lg text-sm" placeholder="Contoh: Alat Pelindung Diri" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">Jumlah Standar (semua GI)</label>
                  <input type="number" min="0" value={newApd.jumlah_standar}
                    onChange={(e) => setNewApd({...newApd, jumlah_standar: parseInt(e.target.value) || 0})}
                    className="w-full px-3 py-2 border rounded-lg text-sm" placeholder="0" />
                </div>
              </div>
              <button onClick={addApd} disabled={isSaving}
                className="mt-3 bg-green-700 text-white px-4 py-2 rounded-lg text-sm hover:bg-green-600 disabled:opacity-50">
                {isSaving ? 'Menyimpan...' : '\uD83D\uDCBE Simpan Item APD'}
              </button>
            </div>
          )}

          {isLoading ? <div className="flex justify-center p-8"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600"></div></div> : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">No</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nama Item APD</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Kategori</th>
                    <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Standar</th>
                    <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Aksi</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {apdList.map((apd, i) => (
                    <tr key={i} className="hover:bg-gray-50">
                      <td className="px-4 py-3 text-center text-gray-500">{apd.no_urut}</td>
                      {editApd?.id === apd.id ? (
                        <>
                          <td className="px-4 py-3 text-gray-800">{apd.nama_item}</td>
                          <td className="px-4 py-3 text-gray-500">{apd.kategori}</td>
                          <td className="px-4 py-3 text-center">
                            <input type="number" min="0" value={editApd.jumlah_standar}
                              onChange={(e) => setEditApd({...editApd, jumlah_standar: parseInt(e.target.value)})}
                              className="w-16 px-2 py-1 border rounded text-center text-sm" />
                          </td>
                          <td className="px-4 py-3 text-center">
                            <button onClick={saveApd} disabled={isSaving}
                              className="text-xs bg-green-600 text-white px-2 py-1 rounded mr-1">💾</button>
                            <button onClick={() => setEditApd(null)}
                              className="text-xs bg-gray-200 text-gray-700 px-2 py-1 rounded">✕</button>
                          </td>
                        </>
                      ) : (
                        <>
                          <td className="px-4 py-3 text-gray-800">{apd.nama_item}</td>
                          <td className="px-4 py-3 text-gray-500">{apd.kategori}</td>
                          <td className="px-4 py-3 text-center font-bold text-gray-800">{apd.jumlah_standar}</td>
                          <td className="px-4 py-3 text-center">
                            <button onClick={() => setEditApd({...apd})}
                              className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded hover:bg-blue-200">✏️ Edit</button>
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ===== P3K ===== */}
      {activeTab === 'p3k' && (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100">
          <div className="p-4 border-b border-gray-100 flex justify-between items-center">
            <h2 className="font-bold text-gray-800">Master Item P3K ({p3kList.length} item)</h2>
            <button onClick={() => setShowAddP3k(!showAddP3k)}
              className="bg-green-700 text-white px-3 py-1.5 rounded-lg text-sm hover:bg-green-600">
              {showAddP3k ? '✕ Batal' : '+ Tambah Item P3K'}
            </button>
          </div>

          {showAddP3k && (
            <div className="p-4 bg-green-50 border-b border-gray-100">
              <h3 className="font-bold text-green-800 mb-3">Tambah Item P3K Baru</h3>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">Nama Item</label>
                  <input value={newP3k.nama_item} onChange={(e) => setNewP3k({...newP3k, nama_item: e.target.value})}
                    className="w-full px-3 py-2 border rounded-lg text-sm" placeholder="Nama item P3K" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">Jumlah Standar</label>
                  <input type="number" min="0" value={newP3k.jumlah_standar}
                    onChange={(e) => setNewP3k({...newP3k, jumlah_standar: parseInt(e.target.value)})}
                    className="w-full px-3 py-2 border rounded-lg text-sm" />
                </div>
              </div>
              <button onClick={addP3k} disabled={isSaving}
                className="mt-3 bg-green-700 text-white px-4 py-2 rounded-lg text-sm hover:bg-green-600 disabled:opacity-50">
                {isSaving ? 'Menyimpan...' : '💾 Simpan Item P3K'}
              </button>
            </div>
          )}

          {isLoading ? <div className="flex justify-center p-8"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600"></div></div> : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">No</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nama Item P3K</th>
                    <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Standar</th>
                    <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Aksi</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {p3kList.map((p3k, i) => (
                    <tr key={i} className="hover:bg-gray-50">
                      <td className="px-4 py-3 text-center text-gray-500">{p3k.no_urut}</td>
                      {editP3k?.id === p3k.id ? (
                        <>
                          <td className="px-4 py-3">
                            <input value={editP3k.nama_item} onChange={(e) => setEditP3k({...editP3k, nama_item: e.target.value})}
                              className="w-full px-2 py-1 border rounded text-sm" />
                          </td>
                          <td className="px-4 py-3 text-center">
                            <input type="number" min="0" value={editP3k.jumlah_standar}
                              onChange={(e) => setEditP3k({...editP3k, jumlah_standar: parseInt(e.target.value)})}
                              className="w-16 px-2 py-1 border rounded text-center text-sm" />
                          </td>
                          <td className="px-4 py-3 text-center">
                            <button onClick={saveP3k} disabled={isSaving}
                              className="text-xs bg-green-600 text-white px-2 py-1 rounded mr-1">💾</button>
                            <button onClick={() => setEditP3k(null)}
                              className="text-xs bg-gray-200 text-gray-700 px-2 py-1 rounded">✕</button>
                          </td>
                        </>
                      ) : (
                        <>
                          <td className="px-4 py-3 text-gray-800">{p3k.nama_item}</td>
                          <td className="px-4 py-3 text-center font-bold text-gray-800">{p3k.jumlah_standar}</td>
                          <td className="px-4 py-3 text-center">
                            <button onClick={() => setEditP3k({...p3k})}
                              className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded hover:bg-blue-200">✏️ Edit</button>
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
